import { defineMessages } from "react-intl";

export const VALIDATION_MESSAGES = defineMessages({
  required: {
    id: "ProjectStepForm.field.required",
    description: "Project creation required field message",
    defaultMessage: "This field is required"
  }
})

export const PLACEHOLDER_MESSAGES = {
  projectPhotos: {
    id: "ProjectStepForm.step4.field.projectPhotos",
    description: "Placeholder to field projectPhotos",
    defaultMessage: "Fotos del proyecto"
  }
}